import { Flex, Spinner, TagLabel, Text } from "@chakra-ui/react";

import { FeatureAutocompleteSelect } from "@/common/components/Autocomplete/FeatureAutocompleteSelect";
import { FeatureDisplay } from "@/feature/components/FeatureDisplay";
import { useFeatureNamesData } from "@/feature/data/useFeatureNamesData";
import {
  operatorDisplayName,
  relevantOperators,
} from "@reflag/shared/attributeFilter";
import { FeatureTargetingFilter } from "@reflag/shared/filter";

import { ManagedFormControl } from "../Form/ManagedFormControl";
import RuleOperator from "../Rule/RuleOperator";
import { TextWordBreak } from "../TextWordBreak";

type FeatureTargetingFilterItemProps = {
  filter: FeatureTargetingFilter;
  isLoading?: boolean;
  noWrap?: boolean;
};

export function FeatureTargetingFilterItem({
  filter,
  isLoading,
  noWrap,
}: FeatureTargetingFilterItemProps) {
  const { data: features } = useFeatureNamesData();

  const feature = features?.find(({ id }) => id === filter.featureId);
  return (
    <TagLabel noOfLines={4} whiteSpace="normal">
      {isLoading ? (
        <Flex align="center" color="dimmed" columnGap={2}>
          <Spinner size="xs" variant="subtle" />
          <TextWordBreak as="span" noWrap={noWrap}>
            Loading filter...
          </TextWordBreak>
        </Flex>
      ) : (
        <Flex align="center" columnGap={1.5} wrap={noWrap ? "nowrap" : "wrap"}>
          {feature && <FeatureDisplay feature={feature} size="sm" />}
          {feature && (
            <Text as="span" color="dimmed">
              {operatorDisplayName[filter.operator]}
            </Text>
          )}
        </Flex>
      )}
    </TagLabel>
  );
}

export function FeatureTargetingFilterFields() {
  const operators = relevantOperators(["featureTargeting"]);

  return (
    <>
      <ManagedFormControl
        name="featureId"
        render={({ field }) => (
          <FeatureAutocompleteSelect bg="appBackground" {...field} valueAsId />
        )}
      />
      <ManagedFormControl
        name="operator"
        render={({ field }) => (
          <RuleOperator {...field} operators={operators} />
        )}
      />
    </>
  );
}
